import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;

export const { thunk: holdTickets, slice: holdTicketsSlice } = getThunkAndSlice<
	{
		ItemIds: Array<number>;
		Comments: string;
		ExpirationDate: string;
	},
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/HoldTickets",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;

		const newData = rootState.pricing.eventInventoryAll.data.map((event) => {
			if (!params.ItemIds.includes(event.Item_ID)) return event;
			return {
				...event,
				On_Hold_Comments: params.Comments ?? "",
				Consignor_Hold: true,
			};
		});
		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId: getInventoryCacheEventId(rootState) }));

		if (rootState.pricing.globalInventory.data.length) {
			const heldListingIds = new Set(
				rootState.pricing.eventInventoryAll.data
					.filter((event) => params.ItemIds.includes(event.Item_ID))
					.map((event) => event.Listing_ID),
			);
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((item) => {
				if (!heldListingIds.has(item.Listing_ID)) return item;
				return { ...item, On_Hold_Comments: params.Comments ?? "", Consignor_Hold: true };
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
